import { useContext, useEffect } from "react";
import { PortalContext, usePortalSettingSet } from "../../../context/portal-context";
import usePageTitle from "../../../hooks/use-page-title";
import CompWLIndex from "./CompWLIndex";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../routes";

const TITLE = "Workplace Learning Reports";

export default function PageWLIndex() {
  usePageTitle(TITLE);
  usePortalSettingSet("label_header", TITLE);
  usePortalSettingSet("is_homepage", false);
  const navigate = useNavigate();
  const { setCustomText } = useContext(PortalContext);
  useEffect(() => {
    setCustomText(TITLE);
  }, []);

  // as of 19th Aug 2025 meeting, client requested not to use redirection mechanism
  // since client prefers redirect, we disable the `<CompWLIndex />` rendering
  // useEffect(() => {
  //   const timers = setTimeout(() => navigate(ROUTES.PORTAL_DASHBOARD, {
  //     replace: true
  //   }), 250);
  //   return () => clearTimeout(timers);
  // }, []);

  return <div data-comp="PageWLIndex">
    <CompWLIndex />
  </div>;
}
